import { render, staticRenderFns } from "./OrganizationInfo.vue?vue&type=template&id=8a08bfe2&"
import script from "./OrganizationInfo.vue?vue&type=script&lang=ts&"
export * from "./OrganizationInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports